module.exports = __webpack_public_path__ + "static/media/clicked.238aab27.svg";